import React from 'react';
import { Box, Container, Typography } from '@material-ui/core';

function PaymentFailComponent() {
  return (
    <Box>
      <Container>
        <Typography variant="h6" gutterBottom>
          Fail
        </Typography>
      </Container>
    </Box>
  );
}

export default PaymentFailComponent;
